import React, { useState } from 'react'
import { apiDelete, apiGet, apiPost } from '../../api'
import { Button, StatusPill, initials, useConfirm } from '../../components/ui'
import { readError } from './shared'

function AdminsTab({ tournament, canManage, saving, run, setError }) {
  const confirm = useConfirm()
  const [phone, setPhone] = useState('')
  const admins = tournament.admins || []
  const creatorId = tournament.creatorId

  const addAdmin = async (e) => {
    e.preventDefault()
    const cleaned = phone.trim()
    if (!cleaned) return
    setError('')
    try {
      const lookup = await apiGet(`/api/users/lookup-by-phone?phone=${encodeURIComponent(cleaned)}`)
      const data = await lookup.json()
      if (!lookup.ok || !data.exists || !data.userId) {
        setError('Fant ingen bruker med det telefonnummeret.')
        return
      }
      await run(async () => {
        const res = await apiPost(`/api/tournaments/${tournament.id}/admins`, { userId: data.userId })
        if (!res.ok) throw new Error(await readError(res, 'Kunne ikke legge til admin'))
        setPhone('')
        return { tournament: await res.json() }
      }, `${data.displayName || 'Bruker'} er nå admin`)
    } catch (err) {
      setError(err.message || 'Kunne ikke legge til admin')
    }
  }

  const removeAdmin = async (admin) => {
    if (!(await confirm({ message: `Fjerne admin-tilgang for ${admin.displayName}?`, confirmLabel: 'Fjern', danger: true }))) return
    run(async () => {
      const res = await apiDelete(`/api/tournaments/${tournament.id}/admins/${admin.userId}`)
      if (!res.ok) throw new Error(await readError(res, 'Kunne ikke fjerne admin'))
      return { tournament: await res.json() }
    }, 'Admin fjernet')
  }

  return (
    <div className="tn-two-col">
      <section className="card tn-card" aria-labelledby="tn-adm-h">
        <div className="tn-head-row">
          <h2 id="tn-adm-h" className="section-title">Administratorer</h2>
          <span className="tn-footnote">{admins.length} {admins.length === 1 ? 'person' : 'personer'}</span>
        </div>
        <ul className="list">
          {admins.map((a) => {
            const isCreator = a.isCreator || a.userId === creatorId
            return (
              <li key={a.userId} className="list-row">
                <span className={`avatar ${isCreator ? '' : 'avatar-mist'}`} aria-hidden="true">{initials(a.displayName)}</span>
                <div className="list-row-main">
                  <span className="tn-admin-name">{a.displayName}</span>
                  {a.phone && <span className="cell-mono muted">{a.phone}</span>}
                </div>
                <StatusPill tone={isCreator ? 'live' : 'neutral'}>{isCreator ? 'Oppretter' : 'Admin'}</StatusPill>
                {canManage && !isCreator && (
                  <Button
                    variant="danger-outline"
                    size="sm"
                    aria-label={`Fjern ${a.displayName}`}
                    disabled={saving}
                    onClick={() => removeAdmin(a)}
                  >
                    Fjern
                  </Button>
                )}
              </li>
            )
          })}
          {admins.length === 0 && <li className="list-row tn-footnote">Ingen administratorer.</li>}
        </ul>
        <span className="tn-footnote">Den som opprettet turneringen kan ikke fjernes.</span>
      </section>

      {canManage && (
        <section className="card tn-card" aria-labelledby="tn-ny-h">
          <div className="stack-sm">
            <h2 id="tn-ny-h" className="section-title">Ny admin</h2>
            <span className="section-sub">
              Personen må ha en Spelaren-bruker. Admins kan endre oppsett, lag og resultater.
            </span>
          </div>
          <form className="stack" onSubmit={addAdmin}>
            <label className="field">
              <span className="field-label">Telefonnummer til ny admin</span>
              <input
                type="tel"
                inputMode="tel"
                autoComplete="off"
                placeholder="Telefonnummer til ny admin"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={saving}
              />
            </label>
            <Button type="submit" block disabled={saving || !phone.trim()}>
              Legg til admin
            </Button>
          </form>
        </section>
      )}
    </div>
  )
}

export default AdminsTab
